// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"139":"728f652c","433":"737b9c72","557":"737b9c72","849":"f7f2fd37"}[chunkId] + ".chunk.css";
};